export default {
	Calendar: {
		width : '330px'
	}
};


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/calendar/calendar-theme-rewrite.js